import React from "react";
import './Note.scss'
import {get} from 'lodash'

export const Note = ({note}) => {
    return <div className="Note">
        <div className="noteTitle">{note.title}</div>
        <div className={`noteContent ${get(note, 'content.length', 0) > 70 ? 'small' : ''}`}>{note.content}</div>
    </div>
}